import {
  ADMIN_TRADING_CONFIGURATION_FORM_PATH,
  BASE_BOTS_BACKTESTING_PATH,
  BASE_BOTS_WITH_ACTION_PATH,
  BASE_PUBLIC_BOT_PATH,
  DCA_PUBLIC_BOTS_PATH,
} from "common/constants";
import { useRouteMatch } from "react-router-dom";
import { BotConfigurationType, QueryBotType } from "@shared/types";
import { capitalizeFirstLetter } from "@shared/common/utils";
import useQuery from "utils/hooks/useQuery";
import { BOT_TYPE_TO_DISPLAY_NAME } from "@shared/features/bots/constants";
import Flex from "common/Boxes/Flex";
import { QUERY_BOT_TYPE_TO_BOT_TYPE } from "@shared/common/constants";
import { useBottomNavigator } from "utils/hooks/misc";

const BotsPageTitle = () => {
  const match = useRouteMatch(BASE_BOTS_WITH_ACTION_PATH);
  const isBacktesting = !!useRouteMatch(BASE_BOTS_BACKTESTING_PATH);
  const { botType: queryBotType, action: queryAction } = (match?.params ||
    {}) as {
    botType?: QueryBotType;
    action?: string;
  };
  const publicBotMatch = useRouteMatch(BASE_PUBLIC_BOT_PATH);
  const publicBotsMatch = useRouteMatch(DCA_PUBLIC_BOTS_PATH);
  const { botType: publicBotQueryBotType } = (match?.params || {}) as {
    botType?: QueryBotType;
  };
  const channelConfigurationsMatch = useRouteMatch<{
    configurationType?: BotConfigurationType;
  }>(ADMIN_TRADING_CONFIGURATION_FORM_PATH);
  const { configurationType } = channelConfigurationsMatch?.params || {};
  const bottomNavigatorData = useBottomNavigator();
  const query = useQuery();
  const botIds = query.get("botIds");
  const botType =
    QUERY_BOT_TYPE_TO_BOT_TYPE[
      queryBotType || publicBotQueryBotType || QueryBotType.ASAP
    ];
  const action = queryAction;
  const isBulkCreate = action === "bulk_create";

  const getActionDisplay = () => {
    if (isBacktesting) return;
    if (action === "my-bots" || !action) return "My";
    if (publicBotMatch) return "Copy";
    if (isBulkCreate) return "Bulk Create";
    return capitalizeFirstLetter(action);
  };

  const botTypeDisplay = BOT_TYPE_TO_DISPLAY_NAME[botType];
  const actionDisplay = getActionDisplay();

  const getTitle = () => {
    if (channelConfigurationsMatch) {
      return `${
        configurationType === BotConfigurationType.SPOT ? "Spot" : "Leverage"
      } Configuration`;
    } else if (bottomNavigatorData.shouldDisplay && !action) {
      return `${botTypeDisplay} Bots`;
    } else if (publicBotsMatch) {
      return "Public DCA Bots";
    }
    return (
      <>
        {botIds ? "Bulk " : ""}
        {actionDisplay ? `${actionDisplay} ` : ""}
        {botTypeDisplay} Bot
        {!actionDisplay || !action || botIds || isBulkCreate ? "s" : ""}
        {isBacktesting ? " Backtesting" : ""}
      </>
    );
  };

  return <Flex $justifyContent="flex-start">{getTitle()}</Flex>;
};

export default BotsPageTitle;
